import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import axios from "axios";
import { useTheme } from "../style/theme";

// Styled Linear Progress Bar
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));

// Circular Progress Bar
function FacebookCircularProgress(props) {
  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        }}
        size={40}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: (theme) =>
            theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={40}
        thickness={4}
        {...props}
      />
    </div>
  );
}

function Home2() {
  const user = JSON.parse(localStorage.getItem("user"));

  const [isMobile, setIsMobile] = useState(false);
  console.log("page is opne");
  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth <= 768);

    checkIsMobile();

    window.addEventListener("resize", checkIsMobile);

    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const { toggleTheme, mode } = useTheme();

  console.log("isMobile", isMobile);
  const [currentUserStorage, setCurrentUserStorage] = useState({
    usedSpace: 0,
  });
  const used = currentUserStorage?.usedSpace || 0;

  useEffect(() => {
    const fetchUserStorage = async () => {
      try {
        const response = await axios.get(
          `https://api.files.clikkle.com:4500/api/user/${user._id}`
        );
        // console.log(response.data.usedSpace, "response.data.usedSpace");
        setCurrentUserStorage({ usedSpace: response.data.usedSpace }); // ✅ fix here
      } catch (error) {
        // console.error("Error fetching user storage:", error);
      }
    };

    fetchUserStorage();
  }, []);

  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];
  };

  const convertToBytes = (value, unit) => {
    const units = {
      Bytes: 1,
      KB: 1024,
      MB: 1024 ** 2,
      GB: 1024 ** 3,
      TB: 1024 ** 4,
    };
    return value * (units[unit] || 1);
  };

  const limit = convertToBytes(5, "GB");
  const percentage = limit > 0 ? (used / limit) * 100 : 0;
  return (
    <>
      <div className="rounded-lg mt-[22px] border border-gray-300 dark:border-[#ffffff3a]">
        <div className="mb-6 mt-[30px] ">
          <p className="md:text-[1.4rem] font-medium  ml-[15px]">
            Clikkle Plus{" "}
          </p>
          <p className="text-base leading-6 mt-[20px] ml-[15px]">
            As a Clikkle Plus member, you get expanded storage, access to
            experts, and more.
          </p>
          <div
            className="ml-[15px]"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "90%",
            }}
          >

            <div
              style={{
                flex: 1,
                margin: "0 10px",
                width: "80%",
                padding: "15px",
              }}
            >
              <p className="mt-[9px] mb-[9px]">Account Storage</p>
              <Box className="w-full flex items-center gap-2 px-3">
                <div
                  style={{
                    position: "relative",
                    width: "30px",
                    height: "30px",
                    marginTop: "5px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      background: mode == "dark" ? "gray" : "black",
                      WebkitMaskImage:
                        'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2"><path d="M12 6a5 5 0 00-5 5h-1a3 3 0 00-3 3 3 3 0 003 3h12a4 4 0 000-8c-.128 0-.253.007-.377.02A5.002 5.002 0 0012 6z"/></svg>\')',
                      WebkitMaskRepeat: "no-repeat",
                      WebkitMaskSize: "contain",
                      maskImage:
                        'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2"><path d="M12 6a5 5 0 00-5 5h-1a3 3 0 00-3 3 3 3 0 003 3h12a4 4 0 000-8c-.128 0-.253.007-.377.02A5.002 5.002 0 0012 6z"/></svg>\')',
                      maskRepeat: "no-repeat",
                      maskSize: "contain",
                    }}
                  />
                </div>
                <div className="w-full">
                  <Typography
                    variant="caption"
                    component="div"
                    mt={1}
                    className="text-[14px]"
                  >
                    {formatBytes(currentUserStorage.usedSpace)} used of 5 GB
                  </Typography>
                  <LinearProgress
                    variant="determinate"
                    value={percentage}
                    color="primary"
                    sx={{ borderRadius: "2px" }}
                  />
                </div>
              </Box>
            </div>
            <div>
              <img src="/images/share.svg" />
            </div>
          </div>
          <div className="border-t border-gray-300 dark:border-[#ffffff3a] border-t-1 border-gray-300">
            <p className="mt-[15px] ml-[15px]" style={{ color: "#3767B1" }}>
              Manage your Clikkle Plus Storage
            </p>
          </div>
        </div>
      </div>

      <div className="rounded-lg mt-[22px] border border-gray-300 dark:border-[#ffffff3a]">
        <div className="mb-6 mt-[20px] ">
          {!isMobile && (
            <div className="flex justify-between">
              <div className="w-[60%]">
                <p className="md:text-[1.4rem] font-medium ml-[15px]">
                  Privacy suggestions available
                </p>
                <p className="mt-[20px] ml-[15px]">
                  Take the privacy checkup and select the settings that are just
                  right for you.
                </p>
              </div>
              <div className="w-[30%] flex items-center justify-end ml-[15px]">
                <img
                  src="images/privicyReport.svg"
                  alt="Privacy Report Icon"
                  className="w-full h-[230px]"
                />
              </div>
            </div>
          )}
          {isMobile && (
            <div>
              <div className="flex ml-[15px] mr-[15px]">
                <p className="text-[1rem]   text-nowrap	">
                  Privacy suggestions available
                </p>
                <img
                  src="/images/certified.svg"
                  alt="Privacy Report Icon"
                  className="w-full  mt-[-6px] h-[3rem] p-2 "
                  style={{ marginRight: "10px" }}
                />
              </div>
              <p className="text-base mt-4 mb-6 ml-[15px]">
                Take the privacy checkup and select the settings that are just
                right for you.
              </p>
            </div>
          )}

          <div className="border-t border-gray-300 dark:border-[#ffffff3a] border-t-1 border-gray-300">
            <p className="mt-[15px] ml-[15px]" style={{ color: "#3767B1" }}>
              Review suggestions (4)
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home2;
